<template>
    <div :id="id">
        <div>
            <div v-if="data_source"
                class="atlas__title"
            >
                {{ data_source }}
            </div>
            <div v-if="data_name || data_update_msg"
                class="atlas__introduction"
            >
                <p class="atlas__introduction__title">
                    {{ data_name }}
                </p>
                <p class="atlas__introduction__update_msg">
                    {{ data_update_msg }}
                </p>
            </div>
        </div>
        <div class="table">
            <table class="table__container">
                <slot name="title" />
                <tr v-for="(title_row, index) in titles" 
                    :key="`title_${index}`"
                >
                    <td v-if="index === 0"
                        class="table__header table__header__first init_dates"
                        :rowspan="titles.length"
                    >
                        預報時間
                    </td>
                    <td v-for="(title, title_index) in title_row" 
                        :key="title_index" 
                        class="table__header table__header__border"
                    >
                        <div v-for="(dates, dates_index) in title" 
                            :key="dates_index"
                            class="row_dates"
                        >
                            {{ dates }}
                        </div>
                    </td>
                </tr>
                <tr 
                    v-for="(sidebar) in sidebars"
                    :key="sidebar" 
                >
                    <td class="table__sidebar init_dates init_date__container">
                        <font> {{ sidebar }} </font>
                    </td>

                    <td v-for="(image, row_index) in images[sidebar]"
                        :key="sidebar + row_index"
                    >
                        <v-img :src="get_src(image, false)"
                            aspect-ratio="1"
                            @click="show_detailed_picture(image)"
                            @error="change_src(image)"
                            id="img_id_for_selector"
                            contain
                        />
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>
    
<script>
    import { 
        alt_src, 
        white_src 
    } from "../../../config/atlas_route_config.js"

    export default {
        name: 'AtalsTableNew',

        props: {
            id: {
                type: String,
                required:true,
            },
            data_source: {
                type: String,
                default: ''
            },
            data_name: {
                type: String,
                default() {
                    return ''
                }
            },
            data_update_msg: {
                type: String,
                default() {
                    return ''
                }
            },
            upper_left_corner: {
                type: String,
                required: true,
            },
            titles: {
                type: Array,
                default() {
                    return []
                },
            },
            sidebars: {
                type: Array,
                default() {
                    return []
                },
            },
            images: {
                type: Object,
                required: true,
            },
            show_custom_title: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                alt_src: alt_src,
                white_src: white_src, 
            }
        },

        methods: {
            show_detailed_picture(image) {
                const is_access_enlarge_image = image.src && !image.failed
                is_access_enlarge_image && this.$emit('open-image-dialog', image.src)
            },

            get_src(image, compression) {
                if (image.failed) {
                    return image.alt_image;
                } else if (image.src == null) {
                    return '';
                    //return this.white_src;
                } else if (compression) {
                    let split_items = image.src.split("/");
                    split_items[split_items.length - 1] = "small_" + split_items[split_items.length - 1];
                    return split_items.join("/");
                } else {
                    return image.src;
                }
            },

            change_src(image) {
                image.failed = true; 
            },            
        },
    }
</script>

<style lang="scss" scoped>
    @import "../../../../css/mixin.scss";

    .table {
        margin-top: 0.5rem;
        width: 100%;
        overflow-x: auto;
        overflow-y: hidden;

        &::-webkit-scrollbar {
            display: none;   
        }

        &__container {
            width: 100%;
            border-collapse: collapse;

            @include tablet {
                min-width: 1000px;
            }

            td {
                width: 76px;
                color: var(--base_black);
                font-size: 14px;
                line-height: 20px;
                letter-spacing: 1px;
            }

            tr {
                td:first-child {
                    border-left: unset;
                }
                td:last-child {
                    border-right: unset;
                }
            }
        }

        &__sidebar {
            background: var(--white-bg);
            border-top: 2px solid #ffffff;
            border-left: 2px solid #ffffff;
            border-right: 2px solid #ffffff;
            font-weight: bold;
        }

        &__header {
            padding: 6px;
            background: var(--white-bg);
            text-align: center;
            font-weight: bold;

            &__border {
                border-top: 2px solid #ffffff;
                border-right: 2px solid #ffffff;
                border-bottom: 2px solid #ffffff;
            }

            &__first {
                border: 2px solid #ffffff;
            }
        }
    }
</style>